<template>
  <div class="forms-actions-manager">
    <span class="forms-actions-manager__count">
      {{ $tc('page.opportunity-forms.selection.count', forms.length, { count: forms.length }) }}
    </span>
    <span class="forms-actions-manager__separator" />
    <FillSplitButton
      is-small
      :label="$t('page.opportunity-forms.selection.fill', { count: forms.length })"
      :templates="templates"
      :default-template-id="defaultTemplateId"
      :disabled="disabled"
      @fill="(templateId) => $emit('fill', templateId)"
    />
    <BaseButton is-small is-outlined has-icon-left @click.native="$emit('download')">
      <BaseIcon name="download" />
      {{ $t('page.opportunity-forms.download') }}
    </BaseButton>
    <BaseButton is-small is-outlined is-danger has-icon-left @click.native="$emit('delete')">
      <BaseIcon name="trash-2" />
      {{ $t('page.opportunity-forms.selection.delete') }}
    </BaseButton>
  </div>
</template>

<script>
import BaseButton from '@/components/base/BaseButton';
import BaseIcon from '@/components/base/BaseIcon';
import FillSplitButton from '@/components/page-opportunity-forms/FillSplitButton.vue';

// Bulk-action bar shown in the forms-list header when rows are selected
// (mirrors TendersActionsManager). Parent owns the actual fill/download/delete.
export default {
  name: 'FormsActionsManager',
  components: { BaseButton, BaseIcon, FillSplitButton },
  props: {
    forms: {
      type: Array,
      default: () => [],
    },
    templates: {
      type: Array,
      default: () => [],
    },
    defaultTemplateId: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss">
.forms-actions-manager {
  // Overlays the header row, anchored to the (positioned) select header cell.
  // `max-content` keeps it sized to its content (one line) instead of being
  // bounded by the narrow select cell, which would wrap the labels.
  position: absolute;
  top: 50%;
  // Clear the 24px select-all checkbox (plus the cell's padding) and leave
  // a visible gap before the pill.
  left: calc(44px + #{$space-3});
  transform: translateY(-50%);
  z-index: 3;
  display: inline-flex;
  align-items: center;
  width: max-content;
  gap: $space-sm;
  padding: $space-1 $space-3;
  white-space: nowrap;
  background: $color-surface-raised;
  border: 1px solid $color-border;
  border-radius: $radius-full;
  box-shadow: $shadow-dropdown;

  &__count {
    @include text-style('label-md');
    color: $color-text-body;
    white-space: nowrap;
    font-variant-numeric: $font-variant-tabular;
  }

  &__separator {
    width: 1px;
    height: 22px;
    background: $color-border;
  }
}
</style>
